import { render, staticRenderFns } from "./UserChallenge.vue?vue&type=template&id=dd636c80&scoped=true&"
import script from "./UserChallenge.vue?vue&type=script&lang=ts&"
export * from "./UserChallenge.vue?vue&type=script&lang=ts&"
import style0 from "./UserChallenge.vue?vue&type=style&index=0&id=dd636c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd636c80",
  null
  
)

export default component.exports